// Import dependencies
import initialiser from '../../utils/initialiser';

const defaultSettings = {
  menuOpenClass: 'is-open',
  menuOpenClassBody: 'has-menu-open',
  menuOpenClassCalendar: 'has-calendar-open',
  menuOpenClassWhite: 'c-header--white-background',
  menuOpenClassNone: 'c-header--transparent-background',
  desktopBp: '1200px',
};

class Navigation {
  constructor(config) {
    const { el, settings } = config;
    const {
      navItem,
      toggleButton,
      subNavtoggleButton,
      backButton,
      headerBackground,
      calendarButton,
      calendarSelector,
      ...settingsWithoutSelectors
    } = settings;

    this.nav = el;
    this.navItems = [...this.nav.querySelectorAll(navItem)];
    this.navToggle = document.querySelector(toggleButton);
    this.subNavToggle = this.nav.querySelectorAll(subNavtoggleButton);
    this.backButton = this.nav.querySelectorAll(backButton);
    this.headerBackground = document.querySelector(headerBackground);
    this.calendarButton = document.querySelector(calendarButton);
    this.calendarSelector = document.querySelector(calendarSelector);
    this.header = document.querySelector('.c-header');

    // Set settings
    this.settings = { ...defaultSettings, ...settingsWithoutSelectors };
    this.mediaQuery = `(max-width: ${this.settings.desktopBp})`;
  }

  // Initialisation Function - Called on each component instance intialisation
  init = () => {
    if (!this.nav || !this.navToggle) return;
    // Call bind events
    this.bindEvents();
  };

  bindEvents = () => {
    if (window.matchMedia(this.mediaQuery).matches) {
      window.addEventListener('hashchange', this.handleCalendarUrlHash);
    }

    this.navToggle.addEventListener('click', this.handleNavToggle);
    if (this.calendarButton) {
      this.calendarButton.addEventListener('click', this.handleNavCalendar);
    }

    if (this.subNavToggle && this.subNavToggle.length) {
      this.subNavToggle.forEach((e) => {
        e.addEventListener('click', this.handleSubNavToggle);
      });

      if (this.headerBackground) {
        this.subNavToggle.forEach((e) => {
          e.parentNode.addEventListener('mouseenter', this.handleEnter);
        });

        this.subNavToggle.forEach((e) => {
          e.parentNode.addEventListener('mouseleave', this.handleLeave);
        });
      }
    }

    if (this.backButton && this.backButton.length) {
      this.backButton.forEach((e) => {
        e.addEventListener('click', this.resetSubNav);
      });
    }
  };

  handleNavToggle = () => {
    this.nav.classList.toggle(this.settings.menuOpenClass);
    this.navToggle.classList.toggle(this.settings.menuOpenClass);
    document.body.classList.toggle(this.settings.menuOpenClassBody);

    document.body.classList.remove(this.settings.menuOpenClassCalendar);
    this.calendarSelector.classList.remove(this.settings.menuOpenClass);

    this.header.classList.toggle('menu-opened');

    setTimeout(() => this.resetSubNav(), 300);
  };

  handleCalendarUrlHash = () => {
    if (window.location.hash === '#whatson') {
      this.handleNavCalendar();
    }

    return false;
  };

  handleNavCalendar = () => {
    document.body.classList.remove(this.settings.menuOpenClassBody);
    this.nav.classList.remove(this.settings.menuOpenClass);

    this.navItems.forEach((item) => {
      if (item.classList.contains(this.settings.menuOpenClass)) {
        item.classList.remove(this.settings.menuOpenClass);
      }
    });
  }

  handleSubNavToggle = (e) => {
    // If desktop return
    if (!window.matchMedia(this.mediaQuery).matches) return;

    // Else prevent default link click and toggle class
    e.preventDefault();
    e.target.parentNode.classList.toggle(this.settings.menuOpenClass);
  };

  resetSubNav = () => {
    this.nav.scrollTop = 0;

    this.subNavToggle.forEach((e) => {
      e.parentNode.classList.remove(this.settings.menuOpenClass);
    });
  };

  handleEnter = () => {
    this.headerBackground.classList.remove(this.settings.menuOpenClassNone);
    this.headerBackground.classList.add(this.settings.menuOpenClassWhite);
  }

  handleLeave = () => {
    this.headerBackground.classList.remove(this.settings.menuOpenClassWhite);
    this.headerBackground.classList.add(this.settings.menuOpenClassNone);
  }
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, Navigation);
